import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoaded: false,
  karmaEarnGame: {},
};

const karmaEarnGameSlice = createSlice({
  name: 'karmaEarnGame',
  initialState,
  reducers: {
    receiveItem: (state, { payload }) => ({
      ...state,
      isLoaded: true,
      karmaEarnGame: payload,
    }),
    reset: () => initialState,
  },
});

export default karmaEarnGameSlice;
